<!--
SPDX-FileCopyrightText: 2023 Marlon W (Mawoka)

SPDX-License-Identifier: MPL-2.0
-->

<script lang="ts">
	import '../app.css';
	import Navbar from '$lib/navbar.svelte';
	import { pathname } from '$lib/stores';
	import { navbarVisible } from '$lib/stores.svelte';

	import { initLocalizationContext } from '$lib/i18n';
	import { browser } from '$app/environment';
	import CommandPalette from '$lib/components/commandpalette.svelte';
	interface Props {
		children?: import('svelte').Snippet;
	}

	let { children }: Props = $props();

	if (browser) {
		pathname.set(window.location.pathname);

		// Theme system: data-theme attr + class="dark" for dark variant
		const applyTheme = (themeId: string) => {
			document.documentElement.dataset.theme = themeId;
			if (themeId === 'dark') {
				document.documentElement.classList.add('dark');
			} else {
				document.documentElement.classList.remove('dark');
			}
		};

		// Auto-activation by date (only if user hasn't manually set theme)
		const getAutoTheme = (): string | null => {
			const now = new Date();
			const month = now.getMonth(); // 0-11
			const day = now.getDate();
			if (month === 9 && day === 31) return 'halloween';
			if (month === 11 && day === 25) return 'christmas';
			if (month === 0 && day === 1) return 'newyear';
			if (month === 1 && day === 14) return 'valentine';
			if (month === 11 || month === 0 || month === 1) return 'winter';
			if (month >= 2 && month <= 4) return 'spring';
			if (month >= 5 && month <= 7) return 'summer';
			if (month >= 8 && month <= 10) return 'autumn';
			return null;
		};

		const savedTheme = localStorage.getItem('theme');
		const manuallySet = localStorage.getItem('themeManuallySet') === 'true';

		if (savedTheme && manuallySet) {
			// User explicitly chose a theme — respect it
			applyTheme(savedTheme);
		} else if (savedTheme === 'dark' || (!savedTheme && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
			// Legacy dark mode support
			applyTheme('dark');
		} else {
			// Try auto seasonal theme
			const autoTheme = getAutoTheme();
			applyTheme(autoTheme ?? savedTheme ?? 'default');
		}
	}
	// Язык решает ОДНА служба (lib/i18n/i18n-service.ts): сохранённый выбор человека,
	// язык браузера, язык по умолчанию. Здесь стоял вписанный руками 'en', который
	// поверх всего этого перезаписывал язык — и человек с русским браузером видел
	// английский, пока сам не переключит (найдено 24.09.2026).
	initLocalizationContext('');
</script>

<!--
	Здесь стоял сбор статистики посещений, отправлявший каждый просмотр страницы на сервер
	автора исходного проекта. Замерено 26.08.2026: на живом сайте он НЕ работал — переменная
	VITE_PLAUSIBLE_DATA_URL закомментирована в frontend/Dockerfile, и в отдаваемой странице нет
	ни одного внешнего script. То есть утечки не было. Но включался он одной раскомментированной
	строкой и слал бы данные наших посетителей чужому человеку, поэтому убран целиком: если
	статистика понадобится, её заводят на своём сервере осознанно, а не расчехляют чужую.
-->

{#if navbarVisible.visible}
	<Navbar />
	<div class="pt-16">
		<div class="z-40"></div>
	</div>
{/if}
{@render children?.()}
<CommandPalette />

<style lang="scss">
	:global(html.dark) {
		:global(#pips-slider) {
			--pip: white;
			--pip-active: white;
		}
	}

	@keyframes background_animation {
		0% {
			background-position: 0% 50%;
		}
		50% {
			background-position: 100% 50%;
		}
		100% {
			background-position: 0% 50%;
		}
	}
</style>
